import { gql } from '@apollo/client';

export type HouseHolder = {
  name?: string;
  relationship: string;
};

export type QueryResult = {
  request: {
    id: string;
    profile: {
      id: string;
      householder?: HouseHolder;
    };
  };
};

export const HOUSE_HOLDER_FRAGMENT = gql`
  fragment Householder on Profile {
    householder {
      relationship
      name
    }
  }
`;

export const HOUSE_HOLDER = gql`
  query householder {
    request {
      id
      profile {
        id
        ...Householder
      }
    }
  }
  ${HOUSE_HOLDER_FRAGMENT}
`;
